function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z",
  fill: "#B8E1F6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6 4.75C5.85938 4.75 5.75 4.85938 5.75 5V11C5.75 11.1406 5.85938 11.25 6 11.25H7.25V10C7.25 9.71875 7.46875 9.5 7.75 9.5H8.25C8.53125 9.5 8.75 9.71875 8.75 10V11.25H10C10.1406 11.25 10.25 11.1406 10.25 11V5C10.25 4.85938 10.1406 4.75 10 4.75H6ZM5 5C5 4.45312 5.45312 4 6 4H10C10.5469 4 11 4.45312 11 5V11C11 11.5469 10.5469 12 10 12H6C5.45312 12 5 11.5469 5 11V5ZM6.5 5.75C6.5 5.60938 6.60938 5.5 6.75 5.5H7.25C7.39062 5.5 7.5 5.60938 7.5 5.75V6.25C7.5 6.39062 7.39062 6.5 7.25 6.5H6.75C6.60938 6.5 6.5 6.39062 6.5 6.25V5.75ZM8.75 5.5H9.25C9.39062 5.5 9.5 5.60938 9.5 5.75V6.25C9.5 6.39062 9.39062 6.5 9.25 6.5H8.75C8.60938 6.5 8.5 6.39062 8.5 6.25V5.75C8.5 5.60938 8.60938 5.5 8.75 5.5ZM6.5 7.75C6.5 7.60938 6.60938 7.5 6.75 7.5H7.25C7.39062 7.5 7.5 7.60938 7.5 7.75V8.25C7.5 8.39062 7.39062 8.5 7.25 8.5H6.75C6.60938 8.5 6.5 8.39062 6.5 8.25V7.75ZM8.75 7.5H9.25C9.39062 7.5 9.5 7.60938 9.5 7.75V8.25C9.5 8.39062 9.39062 8.5 9.25 8.5H8.75C8.60938 8.5 8.5 8.39062 8.5 8.25V7.75C8.5 7.60938 8.60938 7.5 8.75 7.5Z",
  fill: "#006CA3"
});

function SvgPropIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropIcon);
export default __webpack_public_path__ + "static/media/prop-icon.0c4dff8f.svg";
export { ForwardRef as ReactComponent };